import React, { useState, useEffect } from "react";
import styles from "./locations.module.scss";
import BranchesMap from "./google-map";
import Loading from "../../../components/loading";
import { getFunctionsHost } from "../../../utils/paths";

export type RegionLocationData = {
  label: string;
  country: string;
  state?: string;
  groups: Branch[];
};

export type Branch = {
  id?: string;
  city: string;
  state?: string;
  country: string;
  label: string;
  rough_coords?: string;
  group_url: string;
  travelMinutes?: number;
  [key: string]: any;
};

export default function Locations() {
  const [regionsData, setRegionsData] = useState([]);
  const [sortRegionsByName, setSortRegionsByName] = useState(false);
  const [markersData, setMarkersData] = useState<Branch[] | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    async function getLocations() {
      setLoading(true);
      const data = await getLocationsByRegion();
      if (data) {
        data.sort((a: RegionLocationData, b: RegionLocationData) => {
          return a.label.localeCompare(b.label);
        });
        setLoading(false);
        setRegionsData(data);
        setMarkersData(
          data.flatMap((region: RegionLocationData) => region.groups)
        );
      }
    }
    getLocations();
  }, []);


  return (
    <>
      <div className={styles.map}>
        {loading && <Loading />}
        {markersData && <BranchesMap markersData={markersData} />}
      </div>

      <div className="contentContainer">
        <h1>Locations</h1>
        <p>
          There are {markersData && markersData.length} active groups in the
          following locations:
        </p>
        {loading && <Loading />}
        {error && <div>Error: {error}</div>}
        {regionsData.length > 0 && (
          <>
            <div className={styles.regionsContainer}>
              {regionsData.map((regionData: RegionLocationData, i: number) => (
                <div className={styles.regionContainer} key={i}>
                  <h2>{regionData.label}</h2>
                  <ul>
                    {regionData.groups.map((group: Branch, i: number) => (
                      <li key={i}>{group.label}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </>
  );
}

async function getLocationsByRegion() {
  try {
    const requestPath = `${getFunctionsHost()}getAllWhatsappGroups`;
    const response = await fetch(requestPath);
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const data = await response.json();
    return data;
  } catch (err) {
    console.error(err);
    return null;
  }
}
